export const lettersConstants = {
  // clear status
  LETTERS_CLEAR_STATUS_MESSAGE: "LETTERS_CLEAR_STATUS_MESSAGE",

  LETTER_DOWNLOAD_REQUEST: "LETTER_DOWMLOAD_REQUEST",
  LETTER_DOWNLOAD_SUCCESS: "LETTER_DOWMLOAD_SUCCESS",
  LETTER_DOWNLOAD_FAILURE: "LETTER_DOWMLOAD_FAILURE",
};
